export default {"src":"/bnb/_next/static/media/binance-wallet.9b53fa8f.svg","height":20,"width":20};